export default __webpack_public_path__ + "static/chart-active-control-1d058aab9ed66f4279691d984a1fcad1.png";